// extracted by mini-css-extract-plugin
export default {"flex":"time-display_flex__FyCA8","rec":"time-display_rec__Ofa1R"};